import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { SearchOff as NotFoundIcon, Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * 404 Not Found Page
 *
 * Displayed when users navigate to a route that doesn't exist.
 */
const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 3
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <NotFoundIcon
          sx={{
            fontSize: 64,
            color: 'text.secondary',
            mb: 2
          }}
        />

        <Typography variant="h1" sx={{ fontSize: 72, fontWeight: 'bold', color: 'primary.main', mb: 1 }}>
          404
        </Typography>

        <Typography variant="h5" gutterBottom>
          Seite nicht gefunden
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
          >
            Zur Startseite
          </Button>
          <Button
            variant="outlined"
            onClick={handleGoBack}
          >
            Zuruck
          </Button>
        </Box>
      </Paper>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
        Falls Sie glauben, dass dies ein Fehler ist, kontaktieren Sie den Support.
      </Typography>
    </Box>
  );
};

export default NotFound;
